import { Helmet } from "react-helmet-async";

const seoData = {
  "/": {
    title: "BRS Terasz - Alumínium Teraszok, Teraszfedések és Árnyékolók | Egész Magyarország",
    description: "Egyedi tervezésű alumínium teraszok, üveg és polikarbonát teraszfedések, ZIP screen árnyékolók és kocsibeállók kivitelezése Magyarország teljes területén. Kérjen ingyenes felmérést!",
    keywords: "alumínium terasz, teraszfedés, üveg tető, polikarbonát tető, ZIP screen árnyékoló, kocsibeálló, Magyarország"
  },
  "/termekek": {
    title: "Termékeink | BRS Terasz - Alumínium Teraszok és Kültéri Megoldások",
    description: "Fedezze fel alumínium teraszaink, teraszfedéseink, ZIP screen árnyékolóink és kocsibeállóink teljes kínálatát. Standard színek: antracit, fekete, fehér, szürke.",
    keywords: "alumínium terasz, nyitott terasz, üvegfalú terasz, szabadon álló terasz, teraszfedés, árnyékoló, kocsibeálló"
  },
  "/referenciak": {
    title: "Referenciák | BRS Terasz - Elkészült Projektjeink",
    description: "Tekintse meg elkészült alumínium terasz, teraszfedés, árnyékoló és kocsibeálló projektjeinket. Inspirálódjon referenciáinkból!",
    keywords: "referencia, elkészült projektek, alumínium terasz referencia, teraszfedés referencia"
  },
  "/blog": {
    title: "Blog | BRS Terasz - Tippek, Tanácsok és Inspirációk",
    description: "Hasznos tippek alumínium teraszokról, teraszfedésekről és árnyékolókról. Segítünk a döntésben!",
    keywords: "terasz blog, alumínium terasz tippek, teraszfedés tanácsok, ZIP screen árnyékoló"
  },
  "/kapcsolat": {
    title: "Kapcsolat | BRS Terasz - Kérjen Ingyenes Felmérést!",
    description: "Vegye fel velünk a kapcsolatot! Ingyenes helyszíni felmérés és személyre szabott árajánlat egész Magyarország területén. Tel: +36 70 337 9805",
    keywords: "kapcsolat, ajánlatkérés, ingyenes felmérés, BRS Terasz elérhetőség"
  },
  "/arajanlat-keres": {
    title: "Ajánlatkérés | BRS Terasz - Kérjen Személyre Szabott Árajánlatot!",
    description: "Kérjen ingyenes, személyre szabott árajánlatot alumínium teraszra, teraszfedésre, árnyékolóra vagy kocsibeállóra. Gyors válasz, országos kivitelezés.",
    keywords: "ajánlatkérés, árajánlat, alumínium terasz ár, teraszfedés ár, kocsibeálló ár"
  },
  "/adatkezelesi-tajekoztato": {
    title: "Adatkezelési Tájékoztató | BRS Terasz",
    description: "A BRS Terasz (Boros György E.V.) adatkezelési tájékoztatója a www.brsterasz.hu weboldalra vonatkozóan.",
    keywords: "adatkezelés, adatvédelem, GDPR, tájékoztató"
  }
};

const productSeo = {
  "nyitott-teraszok": {
    title: "Nyitott Alumínium Teraszok | BRS Terasz",
    description: "Fedett, de nyitott kültéri élettér alumínium szerkezettel. Standard színek: antracit, fekete, fehér, szürke. Egyedi méretre gyártás, egész Magyarországon."
  },
  "eltolhato-uvegfalu-teraszok": {
    title: "Eltolható Üvegfalú Teraszok | BRS Terasz",
    description: "Nyitható-zárható üvegezett teraszok alumínium vázszerkezettel. Egész évben használható élettér. Hőszigetelő üveg opció."
  },
  "szabadonallo-teraszok": {
    title: "Szabadon Álló Alumínium Teraszok | BRS Terasz",
    description: "Fali rögzítés nélküli, szabadon pozícionálható alumínium teraszok. Stabil, szélálló szerkezet különböző fedési opciókkal."
  },
  "uveg-terasztetok": {
    title: "Üveg Terasztetők | BRS Terasz",
    description: "Edzett biztonsági üveg terasztetők önhordó alumínium szerkezettel. UV szűrős üveg opció. Prémium megjelenés."
  },
  "polikarbonat-terasztetok": {
    title: "Polikarbonát Terasztetők | BRS Terasz",
    description: "16 mm és 25 mm-es polikarbonát terasztetők opál vagy víztiszta színben. UV álló, könnyű szerkezet, jó hőszigetelés."
  },
  "oldalarnyekolo": {
    title: "Oldalárnyékoló - ZIP Screen Technológia | BRS Terasz",
    description: "ZIP screen technológiás oldalárnyékolók tökéletes szél- és napvédelemmel. Motoros vagy kézi vezérlés. Széles szövetválaszték."
  },
  "tetoarnyekolo": {
    title: "Tetőárnyékoló - ZIP Screen Technológia | BRS Terasz",
    description: "Tetőre szerelhető ZIP screen árnyékolók hatékony hővédelemmel. Nyáron akár 10-15 fokkal csökkenti a hőmérsékletet."
  },
  "kocsibeallok": {
    title: "Alumínium Kocsibeállók | BRS Terasz",
    description: "Stílusos alumínium kocsibeállók 1-3 autós kivitelben. Polikarbonát vagy üveg fedés, UV szűrő bevonat. Oldalfal opciók."
  }
};

export const SEO = ({ path, productCategory }) => {
  let seo;
  if (productCategory && productSeo[productCategory]) {
    seo = productSeo[productCategory];
  } else {
    seo = seoData[path] || seoData["/"];
  }

  const url = `https://brsterasz.hu${path || "/"}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "BRS Terasz",
    "description": "Alumínium teraszok, teraszfedések, ZIP screen árnyékolók és kocsibeállók kivitelezése Magyarország teljes területén.",
    "url": "https://brsterasz.hu",
    "telephone": "+36703379805",
    "email": "info@brsterasz.hu",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Móra Ferenc utca 4",
      "addressLocality": "Komárom",
      "postalCode": "2903",
      "addressCountry": "HU"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Magyarország"
    },
    "serviceType": [
      "Alumínium terasz építés",
      "Teraszfedés",
      "ZIP screen árnyékoló",
      "Kocsibeálló építés"
    ],
    "priceRange": "$$"
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
